import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from './../../../../../store/slices/projectsSlice';
import { fetchAllCompletedTasks } from './../../../../../store/slices/ProjectCompletedTask';
import { fetchAllOngoingTasks } from './../../../../../store/slices/ProjectOngoingTask';
import { fetchAllAssignedTasks } from './../../../../../store/slices/ProjectAssignedTaskSlice';
import { getAllProjectRequests } from './../../../../../store/slices/projectApprovedTaskSlice';
import { fetchAllTasks } from './../../../../../store/slices/projectRequestedSlice';

const EmployeeReviewHourGraph = () => {

  const dispatch = useDispatch();

    const [taskList, setTaskList] = useState([])
          const [totalHoursAssigned, setTotalHoursAssigned] = useState(0);
    const [totalHoursSpent,setTotalHoursSpent] = useState(0);


  // const { allProjects } = useSelector((state) => state.projectApprovedTask);
  // const { allOngoingTasks } = useSelector((state) => state.projectOngoingTasks);
  // const { completeTask } = useSelector((state) => state.completedTasks);

  const { projects } = useSelector((state) => state.projects);

  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);


  useEffect(() => {
    dispatch(fetchAllTasks());
    dispatch(getAllProjectRequests());
    dispatch(fetchAllAssignedTasks());
    dispatch(fetchAllOngoingTasks());
    dispatch(fetchAllCompletedTasks());
  }, [dispatch]);

    // useEffect(()=>{
    //   const allWorkEntries = projects?.flatMap(task => task?.WorkEntries.map(entry => ({
    //     ...entry,
    //     ProjectName: task?.ProjectName // optional: add project name or other info
    //   })))
    //   .sort((a, b) => new Date(b?.enddate) - new Date(a?.enddate)); // latest on top
    //   setTaskList(allWorkEntries)
    // },[projects])

    useEffect(() => {
  const allWorkEntries = projects?.flatMap(task =>
    (task?.WorkEntries ?? []).map(entry => ({
      ...entry,
      ProjectName: task?.ProjectName // optional
    }))
  )
  ?.sort((a, b) => new Date(b?.enddate) - new Date(a?.enddate)); // latest on top

  setTaskList(allWorkEntries ?? []);
}, [projects]);


  useEffect(() => {
    const total = taskList?.reduce((acc, task) => {
      return acc + (Number(task?.hoursassigned) || 0);
    }, 0);

    setTotalHoursAssigned(Number(total.toFixed(2)));
  }, [taskList]);

    useEffect(() => {
    const total = taskList?.reduce((acc, task) => {
      return acc + (Number(task.hoursspent) || 0);
    }, 0);
    setTotalHoursSpent(Number(total?.toFixed(2)));
  }, [taskList]);


  // const groupedArrayallProjects = Object.values(
  //   allProjects.reduce((acc, task) => {
  //     const project = task.projectName;
  //     if (!acc[project]) {
  //       acc[project] = {
  //         projectName: project,
  //         TypeService: task.TypeService,
  //         tasks: [],
  //       };
  //     }
  //     acc[project].tasks.push(task);
  //     return acc;
  //   }, {})
  // );

  // const groupedArraycompleteTask = Object.values(
  //   completeTask.reduce((acc, task) => {
  //     const project = task.projectName;
  //     if (!acc[project]) {
  //       acc[project] = {
  //         projectName: project,
  //         TypeService: task.TypeService,
  //         tasks: [],
  //       };
  //     }
  //     acc[project].tasks.push(task);
  //     return acc;
  //   }, {})
  // );

  // const Requests = 0;
  const TotalHours =  Number(parseFloat(totalHoursAssigned)?.toFixed(2)) ;
  const TotalHoursSpent =  Number(parseFloat(totalHoursSpent)?.toFixed(2)) 
    


// const data = [
//   { name: "Total Hours", value: Number(parseFloat(TotalHours).toFixed(2)) },
//   { name: "Total Hours Spent", value: Number(parseFloat(TotalHoursSpent).toFixed(2)) },
// ];
const formatter = new Intl.NumberFormat("en-US", {
  notation: "standard", // or "scientific", "compact", etc.
  maximumFractionDigits: 2,
});

const data = [
  { name: "Total Hours", value: formatter?.format(TotalHours) },
  { name: "Total Hours Spent", value: formatter?.format(TotalHoursSpent) },
];



  const COLORS = [
    "#0b53e5",
     "#85ccf6",
    "#1e73f0",
    "#4191f2",
    "#63aef4",
    "#85ccf6",
    "#a7e9f8",
    "#c9f6fa",
    "#d5fafd",
    "#e0feff",
  ];

  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={10}
      >
        {`${data[index]?.value}`}
      </text>
    );
  };

  return (
    <>
      <div className='flex flex-col w-1/2 bg-white rounded-md'>
        <div className='p-1 pl-2 font-semibold'>
          <h1 >
            All Hours
          </h1>
        </div>
        <hr />
        <div
          style={{ position: "relative", width: "100%", height: "450px" }}
          className="bg-white rounded-md"
        >
          {/* Center background circle */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "130px", // match your innerRadius (approx.)
              height: "130px",
              backgroundColor: "#156082", // your desired background color
              borderRadius: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1, // make sure it's behind the text
              pointerEvents: "none",
            }}
          ></div>

          {/* Center Text */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "16px",
              fontWeight: "bold",
              color: "#ffffff",
              zIndex: 2,
              pointerEvents: "none",
            }}
          >
            {totalHoursAssigned}
          </div>

          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius="30%"
                outerRadius="70%"
                dataKey="value"
                startAngle={90}
                endAngle={-270}
                label={renderCustomLabel}
                labelLine={false}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                wrapperStyle={{ zIndex: 9999 }} // Force tooltip to appear above everything
                contentStyle={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
                // formatter={(value, name) => [`${value}`, `${name}`]}
                formatter={(value, name) => [`${Number(value).toFixed(2)}`, name]}
y              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

    </>
  );
};

export default EmployeeReviewHourGraph;
